module.exports = __webpack_public_path__ + "static/img/newCode3.329acf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newCode3.png
// module id = Gwc+
// module chunks = 0